import { round } from 'fitify-utils/src/number'

import { type SubscriptionPlanSchema, PlanType } from '../../types/subscription'

import { retentions } from './generated'

const getPredictedValueRetention = (
  intervalUnit: string,
  intervalLength?: number
): number | undefined => {
  switch (intervalUnit) {
    case 'week':
      return retentions.week
    case 'month':
      return intervalLength === 3 ? retentions.quarter : retentions.month
    case 'year':
      return retentions.year
    default:
      return undefined
  }
}

export const getSubscribePredictedValue = (
  plan?: Pick<
    SubscriptionPlanSchema,
    | 'intervalLength'
    | 'intervalUnit'
    | 'priceTotalValue'
    | 'totalValue'
    | 'type'
  >
): number => {
  if (
    (plan?.type === PlanType.REGULAR || plan?.type === PlanType.DISCOUNTED) &&
    plan?.intervalUnit
  ) {
    const retention = getPredictedValueRetention(
      plan.intervalUnit,
      plan.intervalLength
    )

    if (retention) {
      const VALUE_COEF = 0.5

      const priceIntro = plan.totalValue
      const priceFull = plan.priceTotalValue

      return round((priceIntro + priceFull * (retention - 1)) * VALUE_COEF, 2)
    }
  }

  return plan?.totalValue ?? plan?.priceTotalValue ?? 0
}
